import { forwardRef, useState } from "react";
import { IMaskInput } from "react-imask";

export const TextMaskCustom = forwardRef<HTMLInputElement, any>(
  function TextMaskCustom(props, ref) {
    const { maskValue, value, onChange, onBlur } = props;

    const [focus, setFocus] = useState<boolean>(false);

    const TextMaskStyle: React.CSSProperties = {
      height: 55,
      fontFamily: "Ubuntu",
      width: "100%",
      paddingLeft: "15px",
      boxShadow: "none",
      outlineStyle: "none",
      border: "none",
      font: "inherit",
    };

    return (
      <IMaskInput
        className="inputMask"
        key="InputMaskKey"
        value={value}
        style={TextMaskStyle}
        mask={maskValue}
        lazy={true}
        definitions={{
          a: /[a-zA-Z]/,
        }}
        inputRef={ref}
        placeholder=""
        unmask={false}
        onAccept={(val: any) => {
          if (onChange) {
            const e = {
              target: {
                value: val,
                name: props?.name,
              },
            };
            if (value != val) {
              onChange(e as any);
            }
          }
        }}
        onBlur={(e: any) => {
          setFocus(false);
          if (onBlur) onBlur(e);
        }}
        onFocus={() => setFocus(true)}
      />
    );
  }
);
